document.addEventListener("DOMContentLoaded", function () {
  const btnSidebar = document.getElementById("planificador-sidebar");
  const sidebarSelector = ".p-sidebar-searcher .p-sidebar";
  const mobileMedia = window.matchMedia("(max-width: 1023px)");
  const bodyOpenClass = "has-planner-sidebar-open";
  const overlayId = "plannerSidebarOverlay";

  function getSidebar() {
    return document.querySelector(sidebarSelector);
  }

  function isSidebarOpen() {
    const sidebar = getSidebar();
    return !!(sidebar && sidebar.classList.contains("p-sidebar--open"));
  }

  function ensureOverlay() {
    let overlay = document.getElementById(overlayId);
    if (overlay) return overlay;

    overlay = document.createElement("div");
    overlay.id = overlayId;
    overlay.className = "planner-sidebar-overlay";
    overlay.setAttribute("aria-hidden", "true");
    document.body.appendChild(overlay);

    overlay.addEventListener("click", function () {
      const closeBtn = document.querySelector(
        ".p-sidebar-searcher .p-sidebar.p-sidebar--open .p-link"
      );

      if (closeBtn) {
        closeBtn.click();
        return;
      }

      const action = document.querySelector(".p-sidebar-searcher__action");
      if (action) {
        action.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }
    });

    return overlay;
  }

  function syncSidebarOverlay() {
    ensureOverlay();
    const shouldShow = mobileMedia.matches && isSidebarOpen();

    document.body.classList.toggle(bodyOpenClass, shouldShow);
    document.body.classList.toggle("p-overflow-hidden", shouldShow);
  }

  if (btnSidebar) {
    btnSidebar.addEventListener("click", function (e) {
      e.preventDefault();

      const section = document.querySelector(".p-sidebar-searcher__action");
      if (!section) return;

      ["pointerdown", "mousedown", "mouseup", "click"].forEach((eventType) => {
        section.dispatchEvent(
          new MouseEvent(eventType, {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      });
    });
  }

  const observer = new MutationObserver(syncSidebarOverlay);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });

  window.addEventListener("resize", syncSidebarOverlay);
  mobileMedia.addEventListener("change", syncSidebarOverlay);
  syncSidebarOverlay();
});
